import { FC, ReactNode } from 'react';

import { TabLink } from './TabLink';
import * as s from './TabNavigation.css';
import { getClassNames } from '../../util/css';
import { Stack } from '../Stack/Stack';

type CompoundBucketProps = FC<{
  /** Label used to distinguish the navigation from other navigation */
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
}> & {
  Item: typeof TabLink;
};

const sparkyClassName = 'sparky-tabnavigation';

const TabNavigation: CompoundBucketProps = ({ ariaLabel, className = '', children, fullWidth = true }) => {
  const navClass = getClassNames(
    sparkyClassName,
    s.tabNavigationRecipe({ fullWidth }),
    className,
  );

  return (
    <nav aria-label={ariaLabel} className={navClass}>
      <Stack as="ul" direction="row">
        {children}
      </Stack>
    </nav>
  );
};

TabNavigation.toString = () => `.${sparkyClassName}`;
TabNavigation.displayName = 'TabNavigation';

TabNavigation.Item = TabLink;

export { TabNavigation };
